{
  "common": {
    "price": "Precio",
    "open": "Abrir",
    "close": "Cerrar",
    "high": "Alto",
    "low": "Bajo",
    "bid": "Oferta",
    "ask": "Solicitud",
    "time": "Hora",
    "date": "Fecha",
    "country": "País",
    "name": "Nombre",
    "currency": "Moneda",
    "yes": "Sí",
    "no": "No",
    "exchange": "Intercambio",
    "type": "Tipo",
    "1month": "1 mes",
    "3months": "3 meses",
    "6months": "6 meses",
    "1year": "1 año",
    "messages": {
      "nodata": "No hay información disponible",
      "error": "Error al obtener los datos. Intente volver a cargar la página."
    },
    "currencies": {
      "USD": "Dólar estadounidense",
      "CAD": "Dólar canadiense"
    },
    "shortMonths": {
      "January": "Ene",
      "February": "Feb",
      "March": "Mar",
      "April": "Abr",
      "May": "May",
      "June": "Jun",
      "July": "Jul",
      "August": "Ago",
      "September": "Sep",
      "October": "Oct",
      "November": "Nov",
      "December": "Dic"
    },
    "buttons": {
      "D": "Día",
      "2D": "2 días",
      "W": "S",
      "2W": "2S",
      "M": "M",
      "3M": "3M",
      "YTD": "Acumulado hasta la fecha",
      "Y": "Año",
      "2Y": "2 años",
      "10Y": "10 años",
      "max": "Máx"
    },
    "buy": "Comprar",
    "sell": "Vender"
  },
  "WMainIndex": {
    "chart": "Gráfico",
    "table": "Tabla",
    "trades": "Transacciones",
    "lastClose": "Cerrado por última vez",
    "turnover": "Volumen de negocios",
    "tradedVolume": "Volumen comercial",
    "marketTrend": "Tendencia de mercado",
    "1week": "1 semana",
    "yearToDate": "En lo que va del año",
    "captions": {
      "trades": "Tabla con los detalles de las operaciones",
      "trend": "Tabla con las tendencias de mercado"
    }
  },
  "WMarketList": {
    "header": {
      "ticker": "Ticker",
      "changePlusMinus": "+/-",
      "changePercentage": "%",
      "histClose": "Cierre hist.",
      "sortable": "Clasificable"
    },
    "messages": {
      "norics": "No hay datos disponibles para el instrumento o instrumentos indicados"
    }
  },
  "WMarketTiles": {
    "changePercentage": "Porcentaje de cambio",
    "changeAbsolute": "Cambio abs.",
    "turnover": "Volumen de negocios",
    "messages": {
      "norics": "No hay información disponible.",
      "invalidInput": "Configuración de entrada no válida. Utilice el formato siguiente: setRics([\" .GDAXI \"])"
    },
    "WTickerBand": {}
  },
  "WNewsHeadlines": {
    "placeholders": {
      "symbols": "Añadir símbolo",
      "topics": "Añadir tema",
      "keywords": "Añadir palabra clave"
    },
    "labels": {
      "headline": "Encabezado",
      "source": "Fuente",
      "keywords": "Clave(s)",
      "symbols": "Símbolo(s)",
      "topics": "Tema(s)"
    },
    "messages": {
      "nodata": "No se encontraron encabezados.",
      "incompletedata": "Faltan datos para mostrar la vista seleccionada."
    }
  },
  "WInterestRate": {
    "messages": {
      "paramsError": "El número de parámetros proporcionados para cada columna no es el mismo."
    }
  },
  "WInstrumentInfo": {
    "header": {
      "totvol": "Volumen",
      "bidsize": "Tamaño de la oferta",
      "asksize": "Tamaño de la solicitud",
      "roundlot": "Tamaño del lote"
    }
  },
  "WPriceChart": {
    "controls": {
      "placeholder": "Comparar con",
      "dateFrom": "Desde",
      "dateTo": "A"
    },
    "tooltip": {
      "price": "Precio: {VALUE}",
      "volume": "Volumen: {VALUE}"
    },
    "labels": {
      "shortDays": {
        "Sunday": "Dom",
        "Monday": "Lun",
        "Tuesday": "Mar",
        "Wednesday": "Mié",
        "Thursday": "Jue",
        "Friday": "Vie",
        "Saturday": "Sáb"
      },
      "inputLabel": {
        "day": "Día",
        "month": "Mes",
        "year": "Año"
      },
      "inputPlaceholder": {
        "day": "DD",
        "month": "MM",
        "year": "AAAA"
      }
    }
  },
  "WEstimatesRatios": {
    "analystConsensus": {
      "title": "Consenso de los analistas",
      "strongsell": "Venta muy recomendada",
      "hold": "Retener",
      "strongbuy": "Compra recomendada",
      "targetTitle": "Diferencia con el precio objetivo",
      "low": "52W bajo",
      "high": "52W alto",
      "tp": "TP",
      "recommendation": "Recomendación",
      "tpfull": "Precio objetivo",
      "pltg": "Crecimiento proyectado de LT"
    },
    "titles": {
      "companyInfo": "Información de la empresa",
      "total": "Total",
      "valuationProfit": "Valoración y rentabilidad",
      "forecast": "Predicción",
      "current": "Actual",
      "perShareData": "Datos por acción"
    },
    "table": {
      "marketCap": "Capitalización bursátil en millones",
      "sharesOutstanding": "Acciones en circulación",
      "commonshare": "Accionistas comunes",
      "enterpriseValue": "Valor de la empresa en millones",
      "numberEmployees": "Número de empleados",
      "pe": "Relación precio-beneficio",
      "ps": "Relación precio-ventas",
      "pb": "Relación precio-valor contable",
      "pcf": "Relación precio/flujo de caja",
      "peg": "PEG",
      "earningYield": "Rendimiento de las ganancias",
      "dividendYield": "Rendimiento por dividendo",
      "revenue": "Ingresos en millones",
      "ebit": "EBIT en millones",
      "netIncome": "Ingresos netos en millones",
      "gpm": "Margen de ganancia bruta",
      "roe": "Rendimiento del capital",
      "eps": "Ganancias por acción",
      "rps": "Ingresos por acción",
      "bps": "Valor contable por acción",
      "cfps": "Flujo de efectivo por acción",
      "cps": "Efectivo por acción",
      "dividendPerShare": "Dividendo por acción",
      "captions": {
        "companyInfo": "Tabla con la información de la empresa",
        "valuationProfit": "Tabla con los índices de valor y rentabilidad",
        "perShareData": "Tabla con los datos por acción",
        "total": "Tabla con los datos totales"
      }
    }
  },
  "WCompanyProfile": {
    "titles": {
      "masterData": "Datos maestros",
      "clearingCodes": "Códigos de compensación",
      "keyDates": "Fechas clave",
      "activities": "Actividades",
      "management": "Gestión"
    },
    "table": {
      "companyID": "Id. de la empresa",
      "parValue": "Valor nominal",
      "sharesOutstanding": "Acciones en circulación",
      "marketCap": "Capitalización bursátil en millones",
      "freeFloat": "% de libre circulación",
      "employees": "Empleados",
      "headquarters": "Sede central de la empresa",
      "phone": "Teléfono",
      "fax": "Fax",
      "internet": "Internet",
      "isin": "ISIN",
      "valor": "Valor",
      "cusip": "CUSIP",
      "finYearEnd": "Fin del año fiscal",
      "reportingDateQ1": "Figuras trimestrales I",
      "reportingDateQ2": "Figuras trimestrales II",
      "reportingDateQ3": "Figuras trimestrales III",
      "reportingDateQ4": "Figuras trimestrales IV",
      "reportingDateA": "Informe preliminar de fin de año",
      "captions": {
        "masterData": "Tabla con los datos maestros",
        "clearingCodes": "Tabla con los códigos de compensación",
        "keyDates": "Tabla con las fechas clave",
        "activities": "Sección de actividades",
        "management": "Tabla con detalles de gestión"
      }
    }
  },
  "WFundAllocation": {
    "types": {
      "HOLD": "ACTIVOS",
      "INVCNT": "PAÍS",
      "ASSTALL": "ASIGNACIÓN DE ACTIVOS",
      "INDSECT": "SECTOR DE LA INDUSTRIA",
      "DEBTQUAL": "CALIDAD DE DEUDOR",
      "MATUR": "MADUREZ"
    }
  },
  "WFundAvgAnnualReturns": {
    "tableHeaders": {
      "description": "Descripción",
      "3y": "3 años",
      "5y": "5 años",
      "10y": "10 años",
      "ytd": "En lo que va del año",
      "inc": "En general"
    },
    "lgcbenchmarkid": "Clasificación de fondos Lipper"
  },
  "WPriceYieldChart": {
    "price": "Precio",
    "yield": "Rendimiento",
    "scaling": {
      "absolute": "Absoluto",
      "percent": "Porcentaje"
    },
    "chart": {
      "containerLabel": "Este es un gráfico con datos de precio o rendimiento"
    }
  }
}
